import { trackingApi } from "./tracking";

export const tracker = async (params: {
  mkt_campaign?: string;
  direct_object_id?: string;
  direct_object_property?: string;
  indirect_object_property?: string;
  direct_object_type?: string;
  client_ip?: string;
  session_id?: string;
  on_screen?: string;
  indirect_object_id?: string;
  user_id?: string;
  event_label?: string;
  event_category?: string;
  event_action?: string;
  context_value?: any;
  indirect_object_type?: string;
}) => {
  const { userAgent } = navigator;

  let eventParams = {
    app_category: "landingpage",
    app_env: "prod",
    app_version: "2.0.0",
    client_agent: userAgent,
    client_ip: params?.client_ip,
    client_timestamp: new Date().getTime().toString(),
    context_format: "",
    context_value: params?.context_value,
    direct_object_id: params?.direct_object_id,
    direct_object_property: params?.direct_object_property,
    direct_object_type: params?.direct_object_type,
    event_category: params?.event_category || "payment",
    event: "PNS_NBN",
    event_action: params?.event_action,
    event_label: params?.event_label,
    from_screen: "",
    indirect_object_id: params?.indirect_object_id,
    indirect_object_property: params?.indirect_object_property,
    indirect_object_type: params?.indirect_object_type,
    mkt_campaign: params?.mkt_campaign,
    mkt_content: "",
    mkt_medium: "",
    mkt_source: "",
    mkt_term: "",
    on_screen: params?.on_screen,
    session_id: params?.session_id,
    user_id: params?.user_id,
  };
  eventParams = {
    ...eventParams,
    ...params,
  };

  const response = await trackingApi.trackerEvent(eventParams);
};
